class CustomSelect {
    constructor(el) {
        this.el = el;
        this.attachListeners();
    }

    attachListeners() {
        this.el.addEventListener('change', () => {
            location.href = this.el.value;
        });
    }
}

export default el => new CustomSelect(el);
